import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, computed, EventEmitter, input, Input, OnInit, Output } from '@angular/core';

import { MaterialDisabledActionDirective } from '../../../directives/material-disabled-action.directive';
import { MaterialTargetDirective } from '../../../directives/material-target.directive';
import { MaterialItemListStatusClass } from './material-item-list.enum';

@Component({
    selector: 'ecm-mat-item-list',
    templateUrl: 'material-item-list.html',
    styleUrls: ['material-item-list.css'],
    standalone: true,
    imports: [MaterialTargetDirective, NgClass, MaterialDisabledActionDirective, NgTemplateOutlet],
})
export class MaterialItemListComponent implements OnInit {
    /**
     * Id may be provide to filter event emitter return in parent component
     * @type {string} id
     */
    public readonly id = input<string>(undefined);

    /**
     * Path item
     * @type {string} itemPath
     */
    @Input() public itemPath?: string;

    /**
     * Status item
     * @type {string} itemStatus : critical | alert | danger | warning | info | success
     */
    @Input() public itemStatus?: 'critical' | 'alert' | 'danger' | 'warning' | 'info' | 'success';

    /**
     * Picto item
     * @type {string} itemIcon
     */
    @Input() public itemIcon?: string;

    /**
     * Label item
     * @type {string}  itemLabel
     */
    readonly itemLabel = input<string>();

    /**
     * Text item
     * @type {string|array}  itemText
     */
    readonly itemText = input<string | string[]>();

    readonly displayedText = computed<string[]>(() => {
        const val = this.itemText();
        if (!val) return [];
        return typeof val === 'string' ? [val] : val;
    });

    /**
     * Alt label item
     * @type {string} itemAlt
     */
    itemAlt = input<string>("Information de l'image de votre item");

    /**
     * Is disabled state
     * @param {boolean} isDisabled
     */
    readonly isDisabled = input<boolean>(false);

    /**
     * Is disabled for eclair
     * @param {boolean} [isDisabledEclair=false]
     */
    readonly isDisabledEclair = input<boolean>(false);

    /**
     * Is highlight state
     * @param {boolean} isHighlight
     */
    readonly isHighlight = input<boolean>(false);

    /**
     * Displays spinner
     */
    readonly isLoading = input<boolean>(false);

    /**
     * Displays border bottom
     */
    readonly hasNoBorder = input<boolean>(false);

    /**
     * Feedback data-e2e tag
     * 3 tags will be added to the DOM
     * {e2e}-{style} for the entire div
     * {e2e}-{style}-primary for the primary text
     * {e2e}-{style}-secondary for the secondary text
     * @type {string} e2e
     */
    @Input() public e2e?: string;

    /**
     * Accessible label for the link, overrides the auto-computed one.
     * When not provided, the label is built from itemLabel + itemText + itemStatus.
     * @type {string} ariaLabel
     */
    readonly ariaLabel = input<string>();

    /**
     * Event emitter
     */
    @Output() public materialItemListEvent: EventEmitter<any> = new EventEmitter<any>();

    readonly computedAriaLabel = computed<string>(() => {
        return [this.itemLabel(), ...this.displayedText()].join(', ');
    });

    public ngOnInit(): void {
        this.e2e = this.e2e ? this.e2e : 'e2e-material-list-item';
    }

    /**
     * Get css class for status display
     * @param {string} status : "critical" | "alert" | "danger" | "warning" | "info" | "success";
     * @returns {string}
     */
    public getCssClassFromStatus(status: string): string {
        return typeof status === 'string' && MaterialItemListStatusClass[status]
            ? MaterialItemListStatusClass[status]
            : undefined;
    }

    /**
     * Emit event on item list action
     * we passe all object
     */
    public materialItemListConfirm(): void {
        this.materialItemListEvent.emit();
    }
}
